/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Grid, Paper, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../contexts/authContext";
import { backgroundStyle, btnStyle, h3Style, logoStyle, paperStyle, pStyle } from "./styles";

const RegisterComplete: React.FC<any> = () => {
  /* States and context declaration */

  const authContext = useContext(AuthContext);
  const history = useHistory();

  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as unknown as undefined;
  }, [authContext]);

  const onGoToDashBoard = async (e: any) => {
    history.push("/dashboard");
  };

  return (
    <div style={backgroundStyle}>
      <Grid>
        <Paper elevation={1} style={paperStyle}>
          <div style={{ margin: "0px auto", width: "315px" }}>
            <Grid style={logoStyle}>
              <h3 style={h3Style}>Email Verified</h3>
              <p style={pStyle}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor.
              </p>
            </Grid>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={btnStyle}
              fullWidth
              onClick={(e) => {
                onGoToDashBoard(e);
              }}
            >
              View Dashboard
            </Button>
          </div>
        </Paper>
      </Grid>
    </div>
  );
};

export default RegisterComplete;
